import React, { Component } from 'react';
import { toast } from 'react-toastify';
import Sidebar from './sidebar';
import Header from './header';
import Message from './message';
import ChatInput from './chatInput';
import { saveChat } from '../services/chatService';

class Container extends Component {
  ismounted = false;

  constructor(props) {
    super(props);
    this.chatInputChild = React.createRef();
  }

  state = {
    newMessage: [],
    selectedCode: '',
    message: '',
    isSubmitting: false,
    bgColor: '#f0eeee',
  }

  handleSendMessage = async (message) => {
    this.setState(prevState => ({
      isSubmitting: !prevState.isSubmitting,
    }));
    const messageLengt = message.length;
    if (messageLengt === 0) return null;
    try {
      const textMessage = { message };
      const { data } = await saveChat(textMessage);
      const { results: messageResponse } = data;
      const response = [...messageResponse].reverse();
      this.setState(prevState => ({
        newMessage: [...prevState.newMessage, ...response],
        selectedCode: '',
        message: '',
        isSubmitting: false,
      }), () => this.chatInputChild.current.focusMessageInput());
    } catch (ex) {
      if (ex.response && ex.response.status >= 400) {
        const { message: errMessage } = ex.response.data;
        if (errMessage) {
          toast.warn(errMessage, {
            autoClose: 6000,
            hideProgressBar: true,
          });
        }
        if (this.chatInputChild.current) {
          this.chatInputChild.current.focusMessageInput();
        }
      }
    }
    return null;
  }

  handleColorSelected = (color) => {
    this.setState(() => ({
      bgColor: color,
    }));
  }

  handleResetMessage = () => {
    this.setState({ newMessage: [] });
  }

  handleCodeSelected = (code) => {
    this.setState({ selectedCode: code, message: code });
  }

  handleInputMessage = (message) => {
    this.setState({ message });
  }

  render() {
    const {
      selectedCode,
      newMessage,
      bgColor,
      message,
    } = this.state;
    return (
      <div className="container">
        <div className="content">
          <Sidebar
            selectedCode={selectedCode}
            onSelectedCode={this.handleCodeSelected}
          />
          <main className="main-view">
            <Header onColorSelected={this.handleColorSelected} />
            <Message
              {...this.props}
              newMessage={newMessage}
              resetMessage={this.handleResetMessage}
              bgColor={bgColor}
            />
            <ChatInput
              ref={this.chatInputChild}
              onSendMessage={this.handleSendMessage}
              onInputMessage={this.handleInputMessage}
              message={message}
            />
          </main>
        </div>
      </div>
    );
  }
}

export default Container;
